// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_models__Cms from "../../../../packages/models/Cms.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as React from "react";

const initValue_0 = Buhta_models__Cms.Content.$$default;

function initValue_1(param) {
  
}

const initValue = [
  initValue_0,
  initValue_1
];

const context = React.createContext(initValue);

function useContent(param) {
  return React.useContext(context);
}

const Context = {
  initValue: initValue,
  context: context,
  useContent: useContent
};

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const Provider = {
  make: make,
  makeProps: makeProps
};

function useContext(initialContent) {
  const match = React.useReducer((function (content, action) {
    switch (action.TAG) {
      case /* BlogTags */ 0 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: action._0,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* BlogPosts */ 1 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: action._0,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* BlogFavorites */ 2 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: action._0,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* BlogSearch */ 3 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: action._0,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* WikiPage */ 4 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: action._0,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* LibraryTags */ 5 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: action._0,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* LibraryArticles */ 6 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: action._0,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* LibraryFavorites */ 7 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: action._0,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* LibrarySearch */ 8 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: action._0,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* AboutPage */ 9 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: action._0,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* Outsourcing */ 10 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: action._0,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* Requisites */ 11 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: action._0,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* FAQ */ 12 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: action._0,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* HomePage */ 13 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: action._0,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* JobCategories */ 14 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: action._0,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
      case /* MainMenu */ 15 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: action._0,
          pricingPage: content.pricingPage
        };
      case /* PricingPage */ 16 :
        return {
          pricingCategories: content.pricingCategories,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: action._0
        };
      case /* PricingCategories */ 17 :
        return {
          pricingCategories: action._0,
          outsourcings: content.outsourcings,
          blogTags: content.blogTags,
          blogPosts: content.blogPosts,
          blogFavorites: content.blogFavorites,
          blogSearch: content.blogSearch,
          wikiPage: content.wikiPage,
          libraryTags: content.libraryTags,
          libraryFavorites: content.libraryFavorites,
          libraryArticles: content.libraryArticles,
          librarySearch: content.librarySearch,
          aboutPage: content.aboutPage,
          requisites: content.requisites,
          faqs: content.faqs,
          homePage: content.homePage,
          jobCategories: content.jobCategories,
          mainMenus: content.mainMenus,
          pricingPage: content.pricingPage
        };
    }
  }), initialContent);
  return [
    match[0],
    match[1]
  ];
}

function getContent(param) {
  return Belt__Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(typeof __CONTENT__ === "undefined" ? undefined : __CONTENT__), Buhta_models__Cms.Content.$$default, (function (serialized) {
    return Buhta_models__Cms.Content.decode(serialized);
  }));
}

export {
  Context,
  Provider,
  useContext,
  getContent,
}
/* context Not a pure module */
